import script from "./ApiWorkspace.vue?vue&type=script&setup=true&lang=js"
export * from "./ApiWorkspace.vue?vue&type=script&setup=true&lang=js"

import "./ApiWorkspace.vue?vue&type=style&index=0&id=63ad23f3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63ad23f3"]])

export default __exports__